export function checkUserAgreement() {
  const checkHTML = `
    <div class="agreement-box">
      <i class="iconfont icon-squarecheckfill" id="user-agreement-checkbox""></i>
      <span class="agreement-text">我已阅读并接受</span>
      <a class="agreement-link" href="https://qn-help.yuketang.cn/user-agreement.html" target="_blank">雨课堂用户协议</a>、
      <a class="agreement-link" href="https://qn-help.yuketang.cn/privacy-policy.html" target="_blank">隐私政策</a>
    </div>
  `;

  const agreementHTML = `
    <div class="ma-agreement" style="display: none;">
      <span class="f14">请您先阅读</span>
      <a class="agreement-link" href="https://qn-help.yuketang.cn/user-agreement.html" target="_blank">雨课堂用户协议</a>、
      <a class="agreement-link" href="https://qn-help.yuketang.cn/privacy-policy.html" target="_blank">隐私政策</a>
      <br/>
      <span class="f14">点击“同意”开始接受我们的服务</span>
      <div class="agree-btn">同意</div>
    </div>
  `
  
  $('.login-box').append(checkHTML);
  $('#support-socket').prepend(agreementHTML)

  $('#user-agreement-checkbox').on('click', function () {
    $(this).toggleClass('icon-squarecheckfill icon-square');
  
    if ($(this).hasClass('icon-squarecheckfill')) {
      $('.ma-agreement').hide();
      $('.mabox .ma').show();
    } else {
      let isMaVisible = $('.mabox').css('display') === 'block';
      if (isMaVisible) {
        $('.mabox .ma').hide();
        $('.ma-agreement').show();
      }
    }
  });

  $('.ma-agreement .agree-btn').on('click', function() {
    $('#user-agreement-checkbox').trigger('click');
  })
}



// WEBPACK FOOTER //
// ./src/pages/login/user-agreement.js